// extracted by mini-css-extract-plugin
export default {"wrapper":"toggle-switch-rounded_wrapper__iYazU","slider":"toggle-switch-rounded_slider__xaJh-","round":"toggle-switch-rounded_round__XodHf"};